<template>
  <header :class="`card-title ${subtitle ? 'has-subtitle' : ''}`" v-if="title || titleLink">
    <template v-if="title">
      <span>{{ title }}</span>
      <template v-if="titleLink && titleLinkText">
        <a :href="titleLink" @click.prevent="handleLink($event, titleLink)">{{ titleLinkText }}</a>
      </template>
    </template>
    <template v-else-if="!!$slots.title">
      <slot name="title" />
    </template>
    <div class="subtitle" v-if="subtitle">
      {{ subtitle }}
    </div>
    <div :class="`tooltip ${tooltipClass}`" v-if="tooltip">
      <i class="mdi mdi-help-circle" />
      <div class="tooltiptext">{{ tooltip }}</div>
    </div>
    <div class="right-side" v-if="!!$slots['right-side']">
      <slot name="right-side" />
    </div>
  </header>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    subtitleIcon: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: null,
    },
    tooltipClass: {
      type: String,
      default: '',
    },
    titleLink: {
      type: String,
      default: '',
    },
    titleLinkText: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.card-title {
  align-items: flex-end;
  color: #848893;
  display: flex;
  font-size: 16px;
  padding-left: 10px;
  margin-bottom: 6px;
  font-weight: 500;

  @media (min-width: 768px) {
    font-size: 18px;
    margin-bottom: 10px;
  }

  a {
    align-items: center;
    color: var(--color-cta-blue);
    display: flex;
    font-size: 12px;
    font-weight: 500;
    margin-left: 10px;
    line-height: 14px;
    pointer-events: all;
  }

  .tooltip {
    margin-left: auto;
    margin-right: 10px;
  }

  &.has-subtitle {
    flex-wrap: wrap;

    & > span {
      margin-right: 10px;
    }
  }

  .subtitle {
    color: #848893;
    font-size: 14px;
    line-height: 1;
  }

  .right-side {
    margin-left: auto;
    font-size: 14px;
    line-height: 1;
  }
}
</style>
